import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';
import type { QSetReviewWorkflowStepCode } from '@exam-management/task-management';

export enum CommentQSetVariant {
  HIDDEN = 'HIDDEN',
  EMPTY = 'EMPTY',
  PROHIBITED = 'PROHIBITED',
  EDITABLE = 'EDITABLE',
  READONLY = 'READONLY',
}

const variant = {
  [WorkflowRole.TASK_OWNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: CommentQSetVariant.EMPTY,
    [WorkflowStepCode.ReviewQsetInReview]: CommentQSetVariant.PROHIBITED,
    [WorkflowStepCode.ReviewQsetReviewed]: CommentQSetVariant.EDITABLE,
    [WorkflowStepCode.ReviewQsetDone]: CommentQSetVariant.READONLY,
  },
  [WorkflowRole.SUBTASK_ASSIGNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: CommentQSetVariant.EMPTY,
    [WorkflowStepCode.ReviewQsetInReview]: CommentQSetVariant.PROHIBITED,
    [WorkflowStepCode.ReviewQsetReviewed]: CommentQSetVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: CommentQSetVariant.READONLY,
  },
  [WorkflowRole.SUBTASK_ASSIGNEE]: {
    [WorkflowStepCode.ReviewQsetTodo]: CommentQSetVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetInReview]: CommentQSetVariant.EDITABLE,
    [WorkflowStepCode.ReviewQsetReviewed]: CommentQSetVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: CommentQSetVariant.READONLY,
  },
};

export default function getCommentQSetVariant(
  roles: { isOwner: boolean; isAssigner: boolean; isAssignee: boolean },
  workflowStepCode: QSetReviewWorkflowStepCode,
): keyof typeof CommentQSetVariant | null {
  if (roles.isOwner) {
    return variant[WorkflowRole.TASK_OWNER][workflowStepCode];
  }

  if (roles.isAssigner && roles.isAssignee) {
    // REMARK: if users are assigner and assignee, they are always SUBTASK_ASSIGNEE
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  if (roles.isAssigner) {
    return variant[WorkflowRole.SUBTASK_ASSIGNER][workflowStepCode];
  }

  if (roles.isAssignee) {
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  return null;
}
